<nz-page-header nz-affix *ngIf="downloadingRes == 0">
  <nz-page-header-title>
    {{'Bulk Download Report' | locale }}
  </nz-page-header-title>
  <nz-page-header-extra>
  </nz-page-header-extra>
</nz-page-header>
<nz-page-header nz-affix nzBackIcon *ngIf="downloadingRes != 0" (nzBack)="ngOnInit()">
  <nz-page-header-title>
    {{'Bulk Download Report' | locale }}
  </nz-page-header-title>
  <nz-page-header-extra>
  </nz-page-header-extra>
</nz-page-header>
<nz-collapse *ngIf="downloadingRes == 0">
  <nz-collapse-panel nzHeader="Filter" nzActive="true">
    <app-wizard-filter-section [filterFields]="filterFields" (filterButtonClicked)="getDocumentForDownload()"
      [filterButtonIsLoading]="documentIsLoading">
    </app-wizard-filter-section>
  </nz-collapse-panel>
</nz-collapse>

<nz-space style="width: 100%" *ngIf="downloadingRes == 0" nzDirection="vertical">
  <nz-space-item>
    <app-table-section [tableCols]="documentTableCols" [dataset]="dataTable.dataset" [tableName]="dataTable.name"
      [cellSettings]="cellSettings">
    </app-table-section>
  </nz-space-item>
  <nz-space-item>
    <button nz-button nzType="primary" (click)="DownloadFiles()" [nzLoading]="generatingIsLoading">
      {{'Download' | locale }}</button>
  </nz-space-item>
</nz-space>

<ng-container *ngIf="downloadingRes != 0"></ng-container>

<nz-result *ngIf="downloadingRes != 0" [nzStatus]="downloadingRes == 2?'info': 'error'" [nzTitle]="downloadingResTitle"
  [nzSubTitle]="downloadingResMessage">
</nz-result>
